

































import Vue from 'vue'
import * as Tone from 'tone'
import { ChordProgressionChordOrUndefined } from '@/application/models/chordProgression'
import { KeyScaleChord, ScaleInKey } from '@/application/models/ScaleInKey'
import ChordOption from '@/components/ChordOption.vue'
import { Inversion, VariantType } from '@/application/models/chords'

export default Vue.extend({
  props: {
    chords: { type: Array as () => ChordProgressionChordOrUndefined[], required: true},
    scaleInKey: { type: ScaleInKey, required: true },
    isFlats: { type: Boolean, required: true },
    sampler: { type: Tone.Sampler, required: true },
    samplerLoaded: { type: Boolean, required: true },
    edit: { type: Boolean, default: true }
  },
  components: {
    ChordOption
  },
  methods: {
    focusSlot(index: number) {
      this.$emit('focus-slot', index)
    },
    blurSlot(index: number) {
      this.$emit('blur-slot', index)
    },
    updateVariant(variantType: VariantType<KeyScaleChord>, index: number) {
      this.$emit('update-variant', variantType, index)
    },
    updateInversion(inversion: Inversion, index: number) {
      this.$emit('update-inversion', inversion, index)
    },
    updateOctave(octave: number, index: number) {
      this.$emit('update-octave', octave, index)
    },
    onDelete(index: number) {
      this.$emit('delete', index)
    }
  }
})
